// extracted by mini-css-extract-plugin
module.exports = {"link-wrapper":"community-section_link-wrapper__UHJlw","link":"community-section_link__DjLCR"};